import styled from 'styled-components';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const VehicleListWrapper = styled.section<{ isFiltersOpen: boolean }>`
  background-color: ${COLORS.grey5};
  flex: 1;
  padding: 24px;
  width: 100%;
  @media ${device.mobileL} {
    padding: 40px;
  }
  @media ${device.laptop} {
    height: unset;
    overflow-y: unset;
    padding: ${({ isFiltersOpen }) =>
      isFiltersOpen ? '12px 60px 80px 40px' : '12px 60px 80px 60px'};
  }
`;

export const PageHeader = styled.div<{ isFiltersOpen: boolean }>`
  padding: 0;
  width: 100%;

  @media ${device.laptop} {
    padding: ${({ isFiltersOpen }) => (isFiltersOpen ? '32px 0 24px 0' : '32px 0 24px 38px')};
  }
`;

export const Titles = styled.div``;

export const PageTitle = styled.h1`
  font-family: Audi Type Extended;
  font-size: 28px;
  line-height: 44px;
  font-weight: 400;
  letter-spacing: 0.008px;

  @media ${device.laptop} {
    font-size: 40px;
    line-height: 60px;
  }
`;

export const PageDescription = styled.p`
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.grey80};
  padding-top: 8px;
`;
export const CountAndSortWrapper = styled.section<{ scrolled: boolean }>`
  position: ${({ scrolled }) => (scrolled ? 'fixed' : 'initial')};
  background-color: ${COLORS.grey5};
  z-index: 100;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  padding-top: 28px;
  padding-left: ${({ scrolled }) => (scrolled ? '24px' : '0')};
  padding-right: ${({ scrolled }) => (scrolled ? '24px' : '0')};
  box-shadow: ${({ scrolled }) =>
    scrolled && '0px 2px 6px 0px rgba(0, 0, 0, 0.2), 0px 1px 2px 0px rgba(0, 0, 0, 0.1);'};
  @media ${device.mobileL} {
    padding-left: ${({ scrolled }) => (scrolled ? '40px' : '0')};
    padding-right: ${({ scrolled }) => (scrolled ? '40px' : '0')};
  }
  @media ${device.laptop} {
    box-shadow: none;
    position: initial;
    padding-left: 0;
    padding-right: 0;
  }
`;

export const CountAndSort = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const ResultsCount = styled.div`
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey80};
  display: flex;
  flex-direction: column-reverse;
  gap: 4px;
  @media ${device.laptop} {
    flex-direction: row;
  }
`;

export const CountNumber = styled.p`
  font-weight: 700;
`;

export const Sort = styled.div``;

export const SearchData = styled.div``;

export const VehiclesListContainer = styled.section<{ scrolled?: boolean }>`
  /* padding-top: 28px; */
  padding-bottom: 52px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px 24px;
  padding-top: ${({ scrolled }) => scrolled && '162px'};

  @media ${device.laptop} {
    padding-top: 32px;
    justify-content: center;
  }
`;

export const VehicleListElement = styled.ul`
  // to fix accessibility issue
  display: contents;
`;

export const ShowFiltersAndSort = styled.button`
  width: 218px;
  height: 48px;
  background: inherit;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid ${COLORS.black};
  color: ${COLORS.black};
  cursor: pointer;
`;
